import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { facilityApi } from "@bw/shared/api";
import { useQuery } from "@tanstack/react-query";
import { OfferCard, OfferRow } from "../../../common/components/OfferCard";
import { SectionHeader } from "../../../common/components/SectionHeader";

export function HomeOffers() {
  const offers = useQuery({
    queryKey: ["home", "public-promotions"],
    queryFn: () => facilityApi.search({ special_offers: true, limit: 4 }),
    retry: false,
  });
  // Offers are secondary: they appear once loaded rather than adding a second
  // loading announcement beside the feed.
  if (offers.isLoading) return null;
  if (offers.isError) {
    return (
      <Alert severity="info">
        Offers are unavailable right now. Your bookings and activity are
        unaffected.
      </Alert>
    );
  }
  const promoted = (offers.data?.items ?? []).flatMap((facility) =>
    (facility.promotion_summaries ?? []).map((promotion) => ({
      facility,
      promotion,
    })),
  ).slice(0, 4);
  if (!promoted.length) return null;
  return (
    <Stack component="section" aria-labelledby="home-offers-title" spacing={1}>
      <SectionHeader
        id="home-offers-title"
        title="Offers near you"
        action={{ label: "See all", to: "/play?special_offers=true", ariaLabel: "See all offers" }}
      />
      <OfferRow>
        {promoted.map(({ facility, promotion }) => (
          <OfferCard
            key={`${facility.facility_id}:${promotion.promotion_id}`}
            promotion={promotion}
            to={`/facility/${facility.facility_id}`}
            subtitle={facility.name}
          />
        ))}
      </OfferRow>
    </Stack>
  );
}
